import { gql } from "@apollo/client";

export const GENERATE_QUOTE_PDF = gql`
  mutation generateQuotePdf($id: String!) {
    generateQuotePdf(id: $id){
        pdf
    }
  }
`;